import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmAndRecipientsSetpointInformation  } from "../../services/admin-report-data-service/Models";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";

export type UseAlarmSetpointReportParams = {
    organizationID: number,    
    contextGroupID: number,
    includeInActiveAndInvisibleDevices: boolean,
} & BaseUseQueryParameters<IAlarmAndRecipientsSetpointInformation[] | undefined>;

export function useAlarmSetpointReport({
    organizationID,
    contextGroupID,
    includeInActiveAndInvisibleDevices,
    enabled,    
    onSuccess,
    onError
}: UseAlarmSetpointReportParams) {
    return useQuery<IAlarmAndRecipientsSetpointInformation[], RestError>(
        keys.alarmSetpointReport(organizationID, contextGroupID, includeInActiveAndInvisibleDevices),
        ({ signal }) => {
            return AdminReportDataService.getAlarmSetpointReport(
                organizationID,
                contextGroupID,
                includeInActiveAndInvisibleDevices,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}